import { Box, CircularProgress, LinearProgress, Typography } from '@mui/material';
import React from 'react';

const ChannelsLoadingOverlay: React.FC = () => {
  return (
    <Box
      data-testid="channels-loading-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        zIndex: 4,
      }}
    >
      <LinearProgress sx={{ position: 'absolute', top: 0, left: 0, width: '100%' }} />
      <CircularProgress size={48} thickness={4} />
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="subtitle1" fontWeight={600}>
          Searching channels…
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This can take a few seconds while we query Snowflake.
        </Typography>
      </Box>
    </Box>
  );
};

export default ChannelsLoadingOverlay;
